const YANDEX_STAFF = 10;
const TAX_PERCENT = 0.06;
const ACQUIRING_PERCENT = 1;
const COMMISSION_PERCENT = 9;

const DELIVERY_PERCENT = 5.5;
const DELIVERY_MIN = 40;
const DELIVERY_MAX = 400;
const CASHBACK_PERCENT = 0;
const YANDEX_PAYMENT = 0.12; // 0,12 рубля

const BUST_PERCENT = 0; // продвижение

const getLogistic = (v) => {
  const volume_weight = parseFloat(v);
  if (volume_weight < 0.2) {
    return { delivery: 55 };
  }
  if (volume_weight >= 0.2 && volume_weight < 0.5) {
    return { delivery: 60 };
  }
  if (volume_weight >= 0.5 && volume_weight < 1) {
    return { delivery: 65 };
  }
  if (volume_weight >= 1 && volume_weight < 2) {
    return { delivery: 70 };
  }
  if (volume_weight >= 2 && volume_weight < 4) {
    return { delivery: 100 };
  }
  if (volume_weight >= 4 && volume_weight < 6) {
    return { delivery: 180 };
  }
  if (volume_weight >= 6 && volume_weight < 8) {
    return { delivery: 250 };
  }
  if (volume_weight >= 8 && volume_weight < 10) {
    return { delivery: 300 };
  }
  if (volume_weight >= 10 && volume_weight < 12) {
    return { delivery: 400 };
  }
  if (volume_weight >= 12 && volume_weight < 15) {
    return { delivery: 500 };
  }
  if (volume_weight >= 15 && volume_weight < 20) {
    return { delivery: 600 };
  }
  if (volume_weight >= 20 && volume_weight < 25) {
    return { delivery: 800 };
  }
  if (volume_weight >= 25 && volume_weight < 30) {
    return { delivery: 1000 };
  }
  if (volume_weight >= 30 && volume_weight < 35) {
    return { delivery: 1200 };
  }
  if (volume_weight >= 35 && volume_weight < 50) {
    return { delivery: 1400 };
  }
  if (volume_weight >= 50 && volume_weight < 150) {
    return { delivery: 1600 };
  }
  if (volume_weight >= 150) {
    return { delivery: 3500 };
  }
  return { delivery: 600 };
};

const isSpecialTariff = (price) => {
  /*  if (price < 99) {
    return { tariff: true, services: 80 };
  }
  if (price < 299) {
    return { tariff: true, services: 95 };
  }
  if (price < 499) {
    return { tariff: true, services: 115 };
  }*/
  return { tariff: false, services: null };
};

const calcYandexCommission = (p) => {
  const {
    tariffs = {},
    wholesale_packaging = 0,
    package_rub,
    min_quantity = 1,
    volume_weight,
    is_express = false,
  } = p;

  const kvant = min_quantity || 1;

  const price = p.price * kvant;

  let staff = YANDEX_STAFF;

  let packaging = package_rub;

  // const acquiring_data = tariffs.find((item) => item.type === 'AGENCY_COMMISSION');
  const commisson_data = tariffs.find((item) => item.type === 'FEE');

  const percent_acquiring = ACQUIRING_PERCENT;
  const percent_commission = commisson_data ? commisson_data.percent : COMMISSION_PERCENT;

  const bust = ((price * BUST_PERCENT) / 100).toFixed(2);
  const cashback = ((price * CASHBACK_PERCENT) / 100).toFixed(2);
  const acquiring = ((price * percent_acquiring) / 100).toFixed(2);
  const commission = ((price * percent_commission) / 100).toFixed(2);

  const logistic = getLogistic(volume_weight);

  const { tariff, services } = isSpecialTariff(price);

  let delivery = 0;
  let logistic_value = 0;
  if (tariff) {
    delivery = 0;
    logistic_value = 0;
  } else {
    delivery = Math.min(Math.max((price * DELIVERY_PERCENT) / 100, DELIVERY_MIN), DELIVERY_MAX);
    logistic_value = logistic.delivery;
  }

  if (is_express) {
    logistic_value = 0;
    packaging = 20;
    staff = 0;
  }
  const all = tariff
    ? services + parseFloat(acquiring) + parseFloat(cashback) + parseFloat(bust)
    : staff +
    YANDEX_PAYMENT +
    parseFloat(commission) +
    delivery +
    parseFloat(acquiring) +
    parseFloat(cashback) +
    parseFloat(bust) +
    logistic_value;

  let tax = (price - all) * TAX_PERCENT;
  tax = tax > 0 ? tax : 0;

  return {
    volume_weight,
    percent_value: percent_commission,
    percent: commission,
    logistic,
    delivery: delivery.toFixed(2),
    logistic_value: logistic_value.toFixed(2),
    tariff,
    services,
    staff,
    YANDEX_PAYMENT,
    acquiring,
    percent_acquiring,
    cashback,
    CASHBACK_PERCENT,
    bust,
    BUST_PERCENT,
    packaging,
    all: all + tax + wholesale_packaging + packaging,
    tax: tax.toFixed(2),
    DELIVERY_PERCENT,
    DELIVERY_MIN,
    DELIVERY_MAX,
    wholesale_packaging,
  };
};

export const calcYandexProfit = (p = {}) => {
  const kvant = p.min_quantity || 1;

  return Math.ceil(p.price * kvant - p.purchase * kvant * (p.quantity || 1) - calcYandexCommission(p).all);
};

export const calcYandexMarginality = (p) => {
  const kvant = p.min_quantity || 1;
  if (p.purchase) {
    return ((calcYandexProfit(p) * 100) / (p.purchase * (p.quantity || 1) * kvant)).toFixed(1);
  }
  return '-';
};
export default calcYandexCommission;
